import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "border bg-white p-4 border-gray-show rounded-md" }
const _hoisted_2 = { class: "flex space-x-2" }
const _hoisted_3 = { class: "shrink-0" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex flex-col justify-between" }
const _hoisted_6 = { class: "align-middle text-sm font-bold text-left line-clamp-2" }
const _hoisted_7 = { class: "text-xs text-left line-clamp-2" }
const _hoisted_8 = { class: "py-2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "flex justify-between border-b border-gray-show py-2"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "優待価格")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "flex grow justify-end" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-green-lightShow text-xs font-bold align-middle mr-2" }, " 100% OFF ")
], -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "flex justify-between border-b border-gray-show py-2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "優待価格")
], -1)
const _hoisted_16 = { class: "flex grow justify-end" }
const _hoisted_17 = { class: "text-green-lightShow text-lg font-bold align-middle mr-2" }
const _hoisted_18 = { class: "text-gray-400 line-through text-lg font-bold" }
const _hoisted_19 = {
  key: 2,
  class: "flex justify-between border-b border-gray-show py-2"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "優待価格")
], -1)
const _hoisted_21 = { class: "flex grow justify-end" }
const _hoisted_22 = {
  key: 0,
  class: "text-green-lightShow text-lg font-bold align-middle mr-2"
}
const _hoisted_23 = {
  key: 1,
  class: "text-green-lightShow text-lg font-bold align-middle mr-2"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 0,
  class: "flex justify-between border-b border-gray-show py-2"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "優待価格")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "flex grow justify-end" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-green-lightShow text-xs font-bold align-middle mr-2" }, " 100% OFF ")
], -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "flex justify-between border-b border-gray-show py-2"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "支払い金額")
], -1)
const _hoisted_32 = { class: "flex grow justify-end" }
const _hoisted_33 = { class: "text-green-lightShow text-lg font-bold align-middle mr-2" }
const _hoisted_34 = {
  key: 2,
  class: "flex justify-between border-b border-gray-show py-2"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "優待価格")
], -1)
const _hoisted_36 = { class: "flex grow justify-end" }
const _hoisted_37 = {
  key: 0,
  class: "text-green-lightShow text-lg font-bold align-middle mr-2"
}
const _hoisted_38 = {
  key: 1,
  class: "text-green-lightShow text-lg font-bold align-middle mr-2"
}
const _hoisted_39 = {
  key: 1,
  class: "flex justify-between border-b border-gray-show py-2"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm table-cell align-middle" }, "支払い金額")
], -1)
const _hoisted_41 = { class: "flex grow justify-end" }
const _hoisted_42 = { class: "text-green-lightShow text-lg font-bold align-middle mr-2" }
const _hoisted_43 = { class: "py-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-normal text-sm" }, "決済する", -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 1,
  class: "bg-green-show py-2 opacity-50 rounded"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-normal text-sm" }, "申請済", -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-normal text-sm" }, "購入情報を見る", -1)
const _hoisted_50 = [
  _hoisted_49
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLongLeftIcon = _resolveComponent("ArrowLongLeftIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex justify-between",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goVoucherDetail()))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.reserve.voucher?.images[0].imageUrl,
            alt: "",
            class: "h-20 w-20 object-cover"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.reserve.voucher?.name), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.reserve.createDate ? `受付日時：${_ctx.ymd(_ctx.reserve.createDate)}` : ``), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.reserve.status === _ctx.ReserveStatuses.Created)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_ctx.reserve.voucher?.discountType === _ctx.DiscountTypes.Free)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
              : (!!_ctx.reserve.voucher?.discountedPrice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("p", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, " ￥" + _toDisplayString(_ctx.reserve.voucher?.discountedPrice.toLocaleString()), 1),
                      _createVNode(_component_ArrowLongLeftIcon, { class: "h-6 w-6 my-auto mx-0 text-gray-400" }),
                      _createElementVNode("span", _hoisted_18, " ￥" + _toDisplayString(_ctx.reserve.voucher?.price.toLocaleString()), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("p", _hoisted_21, [
                      (
                _ctx.reserve.voucher?.discountType === _ctx.DiscountTypes.Amount ||
                _ctx.reserve.voucher?.discountType === _ctx.DiscountTypes.Rate
              )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.reserve.voucher?.discountValue.toLocaleString()) + " " + _toDisplayString(_ctx.SuffixDiscountValueLabels[_ctx.reserve.voucher?.discountType]), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.reserve.voucher?.summary), 1))
                    ])
                  ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_24, [
            (_ctx.reserve.voucher?.voucherType == _ctx.VoucherTypes.Experience)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (_ctx.reserve.voucher?.discountType === _ctx.DiscountTypes.Free)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
                    : (!!_ctx.reserve.voucher?.discountedPrice)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _hoisted_31,
                          _createElementVNode("p", _hoisted_32, [
                            _createElementVNode("span", _hoisted_33, " ￥" + _toDisplayString(_ctx.reserve.totalPrice.toLocaleString()), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("p", _hoisted_36, [
                            (
                  _ctx.reserve.voucher?.discountType === _ctx.DiscountTypes.Amount ||
                  _ctx.reserve.voucher?.discountType === _ctx.DiscountTypes.Rate
                )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.reserve.voucher?.discountValue.toLocaleString()) + " " + _toDisplayString(_ctx.SuffixDiscountValueLabels[_ctx.reserve.voucher?.discountType]), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.reserve.voucher?.summary), 1))
                          ])
                        ]))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("p", _hoisted_41, [
                    _createElementVNode("span", _hoisted_42, " ￥" + _toDisplayString(_ctx.reserve.totalPrice.toLocaleString()), 1)
                  ])
                ]))
          ]))
    ]),
    _createElementVNode("div", _hoisted_43, [
      (_ctx.reserve.status === _ctx.ReserveStatuses.WaitForPayment)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "bg-green-show py-2 rounded",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goReservePayment && _ctx.goReservePayment(...args)))
          }, _hoisted_45))
        : (_ctx.reserve.status === _ctx.ReserveStatuses.Created)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_48))
          : (
          _ctx.reserve.status === _ctx.ReserveStatuses.Diceded ||
          _ctx.reserve.status === _ctx.ReserveStatuses.Done
        )
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "bg-green-show py-2 rounded",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goReserveReciept && _ctx.goReserveReciept(...args)))
              }, _hoisted_50))
            : _createCommentVNode("", true)
    ])
  ]))
}